import { NgModule } from '@angular/core';
import { AvanoToggleSwitchComponent } from './avano-toggle-switch.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [AvanoToggleSwitchComponent],
  exports: [AvanoToggleSwitchComponent]
})
export class AvanoToggleSwitchModule { }
